import __request__ from "routing/request";
export function list(inputId) {
  return __request__("GET", `/system/inputs/${inputId}/extractors`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function create(inputId, JSONbody) {
  return __request__("POST", `/system/inputs/${inputId}/extractors`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function order(inputId, JSONbody) {
  return __request__("POST", `/system/inputs/${inputId}/extractors/order`, JSONbody, {}, {
    "Accept": []
  });
}
export function terminate(inputId, extractorId) {
  return __request__("DELETE", `/system/inputs/${inputId}/extractors/${extractorId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function update(inputId, extractorId, JSONbody) {
  return __request__("PUT", `/system/inputs/${inputId}/extractors/${extractorId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function single(inputId, extractorId) {
  return __request__("GET", `/system/inputs/${inputId}/extractors/${extractorId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
